import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { finalize } from 'rxjs/operators';
import { ContactDataModel } from 'src/app/contacts/contact-data-model';
import { ContactService } from 'src/app/contacts/contact.service';
import { ContactFormDialogComponent } from '../add-contact/contact-form-dialog/contact-form-dialog.component';

@Component({
    selector: 'app-contact-details-popup',
    templateUrl: './contact-details-popup.component.html',
    styleUrls: ['./contact-details-popup.component.scss']
})
export class ContactDetailsPopupComponent implements OnInit {

    contactData: any;
    contactDataModel = new ContactDataModel();
    contactDetails: any = this.contactDataModel.contactDetails;
    contactId: string;
    isDetailLoading = true;

    constructor(
        public dialog: MatDialog,
        private contactService: ContactService,
        public dialogRef: MatDialogRef<ContactDetailsPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MatDialog) {
    }

    ngOnInit() {
        this.contactData = this.data;
        this.contactId = this.contactData.contactId;
        this.loadItems();
    }

    loadItems() {
        this.isDetailLoading = true;
        this.contactService.getRecord(this.contactId)
            .pipe(finalize(() => (this.isDetailLoading = false)))
            .subscribe(response => {
                this.contactDetails = response.data;
                this.isDetailLoading = false;
            });
    }

    onOpenDialog(): void {
        this.dialog.open(ContactFormDialogComponent, {
            position: {
                right: '0',
            },
            panelClass: 'small_layout',
            hasBackdrop: false,
            data: {
                contactId: this.contactDetails.contactId,
                isEdit: true,
                accountName: this.contactDetails.associatedAccountName,
                accountId: this.contactDetails.accountPrimaryId,
                accountTypeId: this.contactDetails.accountTypeId
            },
        }).afterClosed().subscribe((response: any) => {
            if (response) {
                this.isDetailLoading = true;
                this.contactService.getRecord(this.contactId)
                    .pipe(finalize(() => (this.isDetailLoading = false)))
                    .subscribe(resp => {
                        this.contactDetails = resp.data;
                        this.isDetailLoading = false;
                        const sendingData = {
                            success: true,
                            contactLongId: this.contactId,
                            response: this.contactDetails || null
                        };
                        this.dialogRef.close(sendingData);
                    });
            }
        });
    }

    onScroll(el: HTMLElement) {
        el.scrollIntoView({ behavior: 'smooth' });
    }

    onGoBack(): void {
        this.onClose();
    }

    onSave() {
        const sendingData = {};
        this.dialogRef.close(sendingData);
    }

    onClose(): void {
        this.dialogRef.close(false);
    }

}

